/** Fügt Klassennamen zusammen und lässt alles Leere (`false`, `null`, `undefined`, `''`) weg. */
export function classNames(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
